export enum SelectedDataTypes {
  State = 'state',
  Transition = 'transition'
}
